import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Megaphone, X } from "lucide-react";
import { Button } from "./ui/button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "./ui/dialog";
import api, { fmtDate } from "../lib/api";

const SEEN_KEY = "vtz_seen_releases";
const getSeen = () => {
  try { return JSON.parse(localStorage.getItem(SEEN_KEY) || "[]"); } catch { return []; }
};

export const ReleaseNotes = () => {
  const [releases, setReleases] = useState([]);
  const [open, setOpen] = useState(false);
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    api.get("/releases").then((r) => {
      const seen = getSeen();
      setReleases((r.data.active || []).filter((x) => !seen.includes(x.id)));
    }).catch(() => {});
  }, []);

  const dismiss = () => {
    localStorage.setItem(SEEN_KEY, JSON.stringify([...new Set([...getSeen(), ...releases.map((r) => r.id)])]));
    setHidden(true);
    setOpen(false);
  };

  if (!releases.length || hidden) return null;

  return (
    <>
      <div data-testid="release-banner" className="flex items-center gap-3 bg-[#0D9488] text-white rounded-sm px-4 py-2 mb-4 shadow-sm">
        <Megaphone className="w-5 h-5 shrink-0 text-[#9CA3AF]" />
        <div className="text-sm min-w-0 flex-1">
          <p className="font-semibold truncate">Novosti u aplikaciji ({fmtDate(releases[0].date)}): {releases[0].title}</p>
        </div>
        <Button data-testid="release-view-btn" size="sm" onClick={() => setOpen(true)} className="bg-white/15 hover:bg-white/25 text-white rounded-sm h-8 text-xs shrink-0">
          Pogledaj što je novo
        </Button>
        <button data-testid="release-dismiss-btn" onClick={dismiss} aria-label="Zatvori" className="text-white/60 hover:text-white shrink-0 p-1">
          <X className="w-4 h-4" />
        </button>
      </div>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="rounded-sm max-w-2xl max-h-[85vh] overflow-y-auto" data-testid="release-dialog">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2"><Megaphone className="w-5 h-5 text-[#0D9488]" /> Novosti u aplikaciji</DialogTitle>
            <DialogDescription>Što je novo u aplikaciji Cashline</DialogDescription>
          </DialogHeader>
          <div className="space-y-5">
            {releases.map((r) => (
              <div key={r.id}>
                <p className="text-sm font-bold text-[#0F172A]">{fmtDate(r.date)} — {r.title}</p>
                <ul className="mt-2 space-y-1.5">
                  {r.items.map((it, i) => (
                    <li key={i} className="text-sm text-[#374857] flex gap-2">
                      <span className="text-[#0D9488] font-bold shrink-0">•</span>
                      <span>{it}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
            <div className="flex items-center justify-between gap-2 pt-2 border-t border-[#F1F5F9]">
              <Link to="/novosti" data-testid="release-all-news-link" onClick={dismiss} className="text-sm text-[#0D9488] font-medium hover:underline">
                Sve novosti →
              </Link>
              <Button data-testid="release-ok-btn" onClick={dismiss} className="bg-[#0D9488] hover:bg-[#0F766E] rounded-sm">
                U redu, razumijem
              </Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
